// Visor de archivos xml
// Con este visor de archivos xml , se puede tener acceso a la informacion
// que se encuentra en la base de datos y que contiene los campps necesarios 
// para que se puedan procesar en linea 

import React from 'react'

import { Row , Col, Form} from 'react-bootstrap'

import Select from 'react-select'

export default function ViewXml() {

    const options = [
    ]

  return (
    <div className='d-flex flex-column justify-content-center box-1 backemployer-2 centersearch'>

    
    
    <div className='d-flex flex-column justify-content-center box-1 backemployer-2 mb-5 form-2'  id="page1">

        <Row>
            <Col className='col-8'>
                <h4>Parsear Xml</h4>
            </Col>
        </Row>

        <div className='row'>

            <div className='col-sm-6'>

                    <label for="datestart">Fecha Inicio:</label>

                    <input type="date" id="datestart" name="cddi-start" value={new Date()}  />

            </div>

            <div className='col-sm-6'>

                    <label for="dateend">Fecha Final:</label>

                    <input type="date" id="dateend" name="cddi-end" value={new Date()}  />

            </div>


        </div>

        <div  className='row'> 
            <div className='col-8'>
                      
                <Select options={options}>

                </Select>
            </div> 
            

        </div>

    </div>

    </div>


  )
}
